// The theme's JOIN WAITLIST button for sold-out sizes (main form and mobile sticky bar).
// Regular sold-out sizes use AMP's hidden #BIS_trigger; region-restricted pre-orders use
// the preorder waitlist popup because Shopify still considers those variants available.
if (!customElements.get('waitlist-button')) {
  customElements.define('waitlist-button', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('.product');
      this.input = this.closest('form')?.querySelector('input[name="id"]');
      this.button = this.querySelector('button');
      this.onVariantChange = this.update.bind(this);
      this.onClick = this.open.bind(this);
      this.input?.addEventListener('change', this.onVariantChange);
      this.button?.addEventListener('click', this.onClick);
      this.update();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onVariantChange);
      this.button?.removeEventListener('click', this.onClick);
    }

    update() {
      const json = this.product?.querySelector('variant-radios script[type="application/json"]');
      const variant = json && JSON.parse(json.textContent).find((item) => String(item.id) === this.input?.value);
      this.preorderUnavailable = Boolean(
        variant && this.product.querySelector('product-state-region[data-preorder]') &&
        document.documentElement.classList.contains('preorder-market-unavailable') &&
        variant.inventory_management === 'shopify' && variant.inventory_policy === 'continue' &&
        variant.inventory_quantity <= 0
      );
      this.hidden = !variant || this.product.classList.contains('no-product-variant-selected') ||
        (variant.available && !this.preorderUnavailable);
    }

    open(event) {
      if (this.preorderUnavailable) {
        this.product.querySelector('preorder-waitlist')?.open(event);
      } else {
        this.product?.querySelector('#BIS_trigger')?.click();
      }
    }
  });
}
